import XLSX from 'xlsx'

// Выгрузка вкладок «Выработки сотрудников»: лист сводки и лист блюд по каждому сотруднику
export function exportEmployeeReport(t, fileName, summary, employees, amountKey, incomeKey) {
	const wsSummary = XLSX.utils.aoa_to_sheet(summary)
	wsSummary['!cols'] = summary[0].map((item, index) => ({ wch: index === 1 ? 30 : 14 }))

	var products = [[t('employee'), t('name2'), t('price'), t('sale_price'), t('quantity'), t('sales_amount'), t('income')]]
	for (let i = 0; i < employees.length; i++) {
		var employee = employees[i]
		for (let j = 0; j < (employee.products || []).length; j++) {
			var item = employee.products[j]
			products.push([
				employee.first_name,
				item.name,
				Number(item.price),
				Number(item.sale_price),
				Number(item.total_quantity),
				Number(item[amountKey]),
				Number(item[incomeKey]),
			])
		}
	}
	const wsProducts = XLSX.utils.aoa_to_sheet(products)
	wsProducts['!cols'] = [{ wch: 25 }, { wch: 35 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 14 }, { wch: 14 }]

	const wb = XLSX.utils.book_new()
	XLSX.utils.book_append_sheet(wb, wsSummary, t('total').substring(0, 31))
	XLSX.utils.book_append_sheet(wb, wsProducts, t('products').substring(0, 31))
	XLSX.writeFile(wb, fileName + '.xlsx')
}
